"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineFontSizes = determineFontSizes;

var _Theme = require("../../Theme");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Determines which font sizes/line heights to use for typography.
 */


function determineFontSizes(fontType, size) {
  if (!Array.isArray(size)) {
    var match = _Theme.themeProps.typeSizes[fontType][size];
    return {
      fontSize: "".concat(match.fontSize),
      lineHeight: "".concat(match.lineHeight)
    };
  }

  return size.map(function (s) {
    return _Theme.themeProps.typeSizes[fontType][s];
  }).reduce(function (accumulator, current) {
    return {
      fontSize: [].concat(_toConsumableArray(accumulator.fontSize), ["".concat(current.fontSize)]),
      lineHeight: [].concat(_toConsumableArray(accumulator.lineHeight), ["".concat(current.lineHeight)])
    };
  }, {
    fontSize: [],
    lineHeight: []
  });
}